import { Container, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import _Slider from 'react-slick';
const Slider = (_Slider as any).default || _Slider;
import { useQuery } from '@apollo/client/react';
import gql from 'graphql-tag';
import useMediaQuery from '@mui/material/useMediaQuery';
import { withApollo } from '../../../hoc/withApollo';
import ArticleCard from '../../../components/cards/ArticleCard';
import Link from '../../../components/Link';

const useStyles = makeStyles()((theme) => ({
  cardTitle: {
    color: '#2C367E',
    fontFamily: theme.typography.h5.fontFamily,
    textTransform: 'uppercase',
    fontWeight: '400',
    textAlign: 'center',
    fontSize: '2.2em',
    [theme.breakpoints.down('md')]: { fontSize: '1.4em' },
  },
  actorContainer: {
    paddingTop: '3em',
    paddingBottom: '3em',
    textAlign: 'center',
  },
  border: {
    width: '3em',
    borderColor: '#2C367E',
    borderBottom: 'solid',
    marginLeft: '48%',
    borderBottomColor: '#2C367E',
    color: '#2C367E',
    height: '1em',
    textAlign: 'center',
  },
  buttonGrid: {
    fontSize: '1.2em',
    margin: '1.5em 0 1.5em 0 ',
    color: 'white',
    backgroundColor: '#2C367E',
    border: 'none',
    fontWeight: 'bold',
    borderRadius: '1.5em',
    padding: '0.2em 3em 0.2em 3em',
    minHeight: '2.5em',
    '&:hover': {
      cursor: 'pointer',
      color: '#2C367E',
      backgroundColor: 'white',
      border: '2px solid #2C367E',
    },
    backgroundImage: "url('/arrow.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '5px',
    backgroundPositionY: '-3px',
  },
  articleCarroussel: { paddingTop: '2em' },
  buttonArticle: { paddingTop: '1em', paddingBottom: '1em' },
  article: {
    paddingTop: '3em',
    paddingBottom: '3em',
    textAlign: 'center',
    backgroundColor: 'white',
    overflow: 'hidden',
  },
}));

const GET_ARTICLES = gql`
  query articles($limit: Int, $sort: String, $way: String) {
    articles(limit: $limit, sort: $sort, way: $way) {
      id
      label
      shortDescription
      createdAt
      url
      pictures {
        id
        label
        originalPicturePath
        originalPictureFilename
        position
        logo
        main
      }
    }
  }
`;

interface LastArticleProps {
  id?: string;
}

const LastArticle = ({ id }: LastArticleProps) => {
  const [articleToRender, setArticleToRender] = useState<{ articleData: any } | null>(null);
  const { data: articleData } = useQuery(GET_ARTICLES, {
    variables: { limit: 4, sort: 'createdAt', way: 'DESC' },
  });

  useEffect(() => {
    setArticleToRender({ articleData });
  }, [articleData]);

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const mediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const { classes: styles } = useStyles();
  const maxImageDisplay = !mobile ? (mediumScreen ? 2 : 4) : 1;

  const SampleNextArrow = (props: any) => (
    <div className={props.className} style={{ ...props.style, display: 'block' }} onClick={props.onClick} />
  );
  const SamplePrevArrow = (props: any) => (
    <div className={props.className} style={{ ...props.style, display: 'block' }} onClick={props.onClick} />
  );

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow:
      articleToRender?.articleData &&
      articleToRender.articleData.articles.length > maxImageDisplay
        ? maxImageDisplay
        : articleToRender?.articleData && articleToRender.articleData.articles.length,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <Container className={styles.article} id={id}>
      <Typography variant="h5" className={styles.cardTitle}>
        LES DERNIERS ARTICLES
      </Typography>
      <div className={styles.border} />
      <Slider {...settings} className={styles.articleCarroussel}>
        {articleToRender?.articleData &&
          articleToRender.articleData.articles.map((article: any) => (
            <ArticleCard key={article.id} article={article} />
          ))}
      </Slider>
      <div className={styles.buttonArticle}>
        <Link href="/news">
          <button className={styles.buttonGrid}>VOIR TOUS LES ARTICLES</button>
        </Link>
      </div>
    </Container>
  );
};

export default withApollo()(LastArticle);
